module.exports = __webpack_public_path__ + "img/emptyState.2977473b.svg";